<template>
  <div
    class="form-radio control-group"
    :class="{ error: error }"
  >
    <span class="control-label form-radio__label">
      <abbr
        v-if="required.length >= 1"
        title="Verplicht veld"
      >
        *
      </abbr>
      {{ label }}
    </span>
    <div class="form-radio__options">
      <label
        v-for="option in options"
        :key="option"
        class="form-radio__option"
      >
        <input
          type="radio"
          :value="option"
          :checked="value === option"
          @change="$emit('input', $event.target.value)"
        >
        <span>
          {{ option }}
          <abbr
            v-if="option === requiredAnswer"
            title="Gewenst antwoord"
          >
            *
          </abbr>
        </span>
      </label>
    </div>
    <div
      v-if="error"
      class="form-structure-error-container"
    >
      <div
        v-if="error.input"
        class="help-inline"
      >
        {{ error.input }}
      </div>
      <div
        v-if="error.field"
        class="help-inline"
      >
        {{ error.field }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormRadio',

  schema: [
    {
      name: 'label',
      default: 'Label',
      type: 'FormText',
      label: 'Label',
    },
    {
      name: 'options',
      default: [],
      type: 'FormChips',
      label: 'Opties',
    },
    {
      name: 'required',
      default: false,
      type: 'FormCheckbox',
      label: 'Verplicht',
    },
    {
      name: 'requiredAnswer',
      optionsFrom: 'options',
      type: 'FormSelect',
      label: 'Gewenst antwoord',
    },
  ],

  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [Array, String],
      default: () => '',
    },
    required: {
      type: [Array, Boolean],
      default: false,
    },
    requiredAnswer: {
      type: String,
      default: '',
    },
    error: {
      type: Object,
      default: () => (null),
    },
  },
};
</script>

<style lang="scss">
.form-radio {
  display: flex;
  flex-grow: 1;

  &__label.control-label {
    width: 50%;
    font-size: 14px;
    line-height: 30px;
    margin-right: 20px;
    padding-left: 40px;
    text-align: left;
  }

  &__options {
    width: 50%;
    padding: 5px 0;
    margin-right: 10px;
  }

  &__option {
    align-items: center;
    display: flex;
    line-height: 20px;

    label {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    input {
      margin: 0 5px 0 0;
    }
  }

  .form-structure-error-container {
    display: inline-grid;

    .help-inline {
      height: 26px;
    }
  }
}
</style>
